/* LJDA Cart Drawer — Client Enhancements */
(function () {
  'use strict';

  /* ── Cross-sell ─────────────────────────────────── */
  function initCrossSell() {
    const el = document.querySelector('.ljda-cross-sell[data-product-id]');
    if (!el) return;

    const productId = el.dataset.productId;
    const grid = el.querySelector('.ljda-cross-sell__grid');
    if (!grid || !productId) return;

    // Avoid re-fetching if grid already has cards
    if (grid.children.length > 0) return;

    // Try complementary first, fall back to related
    fetchRecommendations(productId, 'complementary')
      .then(products => {
        if (products && products.length > 0) return products;
        return fetchRecommendations(productId, 'related');
      })
      .then(products => {
        if (!products || products.length === 0) {
          el.style.display = 'none';
          return;
        }
        renderCards(grid, products.slice(0, 4));
        grid.addEventListener('click', handleCrossSellAdd);
      })
      .catch(() => { el.style.display = 'none'; });
  }

  function fetchRecommendations(productId, intent) {
    return fetch(`/recommendations/products.json?product_id=${productId}&limit=6&intent=${intent}`)
      .then(r => r.json())
      .then(data => data.products || []);
  }

  function renderCards(grid, products) {
    grid.innerHTML = products.map(p => {
      const imgSrc = (p.images && p.images[0] && p.images[0].src)
        || (typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image && p.featured_image.src) || '')
        || '';
      const variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
      const price = formatMoney(p.variants && p.variants[0] ? p.variants[0].price : 0);
      return [
        `<div class="ljda-cross-sell__card" data-variant-id="${variantId}">`,
        imgSrc ? `  <img src="${imgSrc}" alt="${escHtml(p.title)}" loading="eager" width="160" height="160">` : '',
        `  <p class="ljda-cross-sell__card-title">${escHtml(p.title)}</p>`,
        `  <p class="ljda-cross-sell__card-price">${price}</p>`,
        `  <button class="ljda-cross-sell__card-btn" type="button"><span>+ Agregar</span></button>`,
        `</div>`,
      ].filter(Boolean).join('\n');
    }).join('');
  }

  function handleCrossSellAdd(e) {
    const btn = e.target.closest('.ljda-cross-sell__card-btn');
    if (!btn) return;
    const card = btn.closest('.ljda-cross-sell__card');
    const variantId = card && card.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.innerHTML = '<span>...</span>';

    // Collect section IDs from all cart-items-component elements
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .filter(el => el.dataset.sectionId)
      .map(el => el.dataset.sectionId)
      .join(',');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: sectionIds }),
    })
      .then(r => r.json())
      .then(cartAddResponse => {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cartAddResponse,
            data: {
              sections: cartAddResponse.sections || null,
              itemCount: 1,
              source: 'ljda-cross-sell',
            },
          },
        }));
        btn.innerHTML = '<span>✓ Agregado</span>';
        setTimeout(() => {
          btn.disabled = false;
          btn.innerHTML = '<span>+ Agregar</span>';
        }, 2000);
      })
      .catch(() => {
        btn.disabled = false;
        btn.innerHTML = '<span>+ Agregar</span>';
      });
  }

  /* ── Note debounce ───────────────────────────────── */
  function initNoteField() {
    const field = document.querySelector('.ljda-note-field');
    if (!field) return;

    let timer;
    field.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ note: field.value }),
        });
      }, 600);
    });
  }

  /* ── Coupon redirect ────────────────────────────── */
  function initCouponForm() {
    const form = document.querySelector('.ljda-coupon-form');
    if (!form) return;

    form.addEventListener('submit', e => {
      e.preventDefault();
      const input = form.querySelector('input');
      if (!input || !input.value.trim()) return;
      const code = encodeURIComponent(input.value.trim());
      window.location.href = `/checkout?discount=${code}`;
    });
  }

  /* ── Mobile swipe-to-close ─────────────────────────── */
  function initSwipeClose() {
    if (window.innerWidth > 749) return;
    const dialog = document.querySelector('cart-drawer-component dialog');
    if (!dialog) return;

    let startY = 0;
    let deltaY = 0;

    dialog.addEventListener('touchstart', e => {
      startY = e.touches[0].clientY;
    }, { passive: true });

    dialog.addEventListener('touchmove', e => {
      deltaY = e.touches[0].clientY - startY;
    }, { passive: true });

    dialog.addEventListener('touchend', () => {
      if (deltaY > 120) {
        const closeBtn = dialog.querySelector('[ref="closeButton"]');
        if (closeBtn) closeBtn.click();
      }
      deltaY = 0;
    });
  }

  /* ── Boot & re-init after cart morph ──────────────────────── */
  function init() {
    initCrossSell();
    initNoteField();
    initCouponForm();
    initSwipeClose();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('cart:update', () => setTimeout(init, 100));

  /* ── Helpers ──────────────────────────────────────── */
  function formatMoney(cents) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 0,
    }).format(Number(cents) / 100);
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();
